// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"0bc1cfab","319":"2bcda660","438":"bee94bb0","670":"663fd906","854":"1eecf0ba"}[chunkId] + ".chunk.css";
};